import Pagination from '@/components/paginationSimple'
import titleBlock from '../components/titleBarBlock'
import MySkeleton from './../components/mySkeleton.vue'
export default {
  name: 'enterpriseTabs',
  components: {
    titleBlock,
    Pagination,
    MySkeleton
  },
  props: {
    tabsInfo: {
      type: Array,
      default: () => []
    },
    activeInfo: {
      type: Array,
      default: () => []
    }
  },
  inject: ['$companyStatus'],
  watch: {
    tabsInfo: {
      deep: true,
      immediate: true,
      handler(val) {
        this.titles.forEach(e => {
          val.forEach(ele => {
            if (ele.name === e.label) {
              e.moduleId = ele.moduleId
              e.num = ele.total
            }
          })
        })

        if (this.titlesMap) {
          const newTitles = []
          for (const key in this.titlesMap) {
            const newKey = this.titlesMap[key]
            newTitles[newKey] = this.titles[key]
          }
          this.$emit('setTitle', newTitles)
        } else {
          this.$emit('setTitle', this.titles)
        }
        // 注册加载器
        if (val.length && !this.observeFlag && this.initObserve) {
          this.observeFlag = true
          this.$nextTick(() => {
            this.initObserve(this.titles, this.titles.map(e => {
              return document.querySelector(`#bm${e.label}`)
            }))
          })
        }
      }
    }
  },
  data() {
    return {
      observeFlag: false
    }
  },
  mounted() {
  },
  filters: {
    showFilter(str) {
      if (typeof str === 'string') {
        if (str.includes('{')) {
          if (str.includes('&quot;')) {
            str = str.replace(/&quot;/g, '"')
          }

          return JSON.parse(str).value
        }
        // strUrl = strUrl.match(/http:\/\/.+/);
        // if (str.match(/^(http:\/\/.+)|(https:\/\/.+)/)) {
        //   if (str.match(/\.(gif|jpg|jpeg|png|webp|GIF|JPG|PNG|WEBP)$/)){

        //   }
        // }
      }
      return str || '--'
    }
  },
  computed: {
    tableDatas() {
      return id => {
        // fieldValue 为老数据 fieldData 是新数据
        const { fieldValue, fieldData } = this.searchActive(id)
        return fieldValue || fieldData
      }
    },

    tableFields() {
      return id => this.searchActive(id).fields || []
    },
    tablePage() {
      return id => this.searchActive(id).currentPage || 1
    },
    tableTotal() {
      return id => this.searchActive(id).total
    },
    columnValue() {
      return (val, id) => {
        if (this.searchActive(id).isNew) {
          if (val === 'null') return '--'
          return val || '--'
        } else {
          return this.$options.filters.showFilter(val) || '--'
        }
      }
    }
  },
  methods: {
    // 地址增加www
    addUrl3W(str) {
      if (!str) return
      const ipv4AllRegex = /^https?:\/\/(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      if(ipv4AllRegex.test(str)){
        return str
      }
      const ipv4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      var newStr = 'http://www.'
      if (!str.includes('http://www.') && !str.includes('https://www.')) {
        if (ipv4Regex.test(str)) {
          return 'http://' + str
        } 
        newStr = newStr + str.replace('http://', '').replace('https://', '').replace('www.', '')
        return newStr
       
      } else {
        return str
      }
    },
    repliceHttps(str) {
      const urlP = /^http:\/\/.+/
      if (str.match(urlP)) {
        return str.replace('http://', 'https://')
      }
      return str
    },
    whichType(str) {
      if (!str) return 'null'
      if (typeof str === 'string') {
        if (str.match(/^\[.*?\]$/)) {
          if (str === '[]') return 'null'
          return 'array'
        }
        if (str.match(/^\{.*?\}$/)) {
          if (str === '{}') return 'null'
          return 'object'
        }
        // let urlP = /^((https?|ftp|file):\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/

        const urlP = /^(http:\/\/.+)|(https:\/\/.+)/
        if (str.match(urlP)) {
          // /http:\/\/.*?(gif|png|jpg)/gi
          if (str.match(/\.(gif|jpg|jpeg|png|webp|GIF|JPG|PNG|WEBP)/gi)) {
            return 'img'
          }
          return 'url'
        }
        return 'string'
      }
      return str
    },
    strTranslation(str) {
      if (str.includes('&quot;')) return str.replace(/&quot;/g, '"')
      return str
    },
    searchActive(id) {
      return this.activeInfo.find(e => e.moduleId === id) || {}
    },
    searchTabs(id) {
      return this.tabsInfo.find(e => e.moduleId === id) || {}
    },
    objParse(str) {
      return JSON.parse(this.strTranslation(str)).value
    },
    handleCurrentChange(val, sign) {
      this.$emit('pageTurn', { pageNum: val, moduleId: this.titles[sign].moduleId, index: sign }) // index 是 titles 的下标
    }
  }
}
